<input
    [formControl]="formControl"
    [formlyAttributes]="field"
    [(ngModel)]="color"
    [style.background]="color"
    [(colorPicker)]="color"
/>
